/** Смещение блока в шагах сетки (col, row) для каждого index. [index][blockIndex] */
const BLOCK_DELTAS: ReadonlyArray<ReadonlyArray<{ col: number; row: number }>> = [
  [
    { col: 0, row: 0 },
    { col: 0, row: 0 },
    { col: 0, row: 0 },
    { col: 0, row: 0 },
  ],
  [
    { col: 0, row: 0 },
    { col: 0, row: 0 },
    { col: 1, row: 0 },
    { col: -1, row: 0 },
  ],
  [
    { col: 0, row: 0 },
    { col: -1, row: 1 },
    { col: 1, row: 0 },
    { col: 0, row: -1 },
  ],
  [
    { col: 1, row: 0 },
    { col: -1, row: 1 },
    { col: 1, row: 0 },
    { col: -1, row: -1 },
  ],
];

/** Translate в пикселях для всех 4 блоков при данном index. stepX/stepY — из констант или из DOM. */
export function getBlockTranslates(index: number, stepX: number, stepY: number): Array<{ x: number; y: number }> {
  const safe = Math.min(3, Math.max(0, index));
  const deltas = BLOCK_DELTAS[safe];

  return deltas.map(({ col, row }) => ({
    x: col * stepX,
    y: row * stepY,
  }));
}
